import { useField } from 'formik';

import { AudienceTypeOptions as AudienceTypeOptionsType } from '../../../../util/demographics';

import { DemographicTargets } from '../DemographicTargets/DemographicTargets';

export const BuildYourAudienceCard = (): JSX.Element | null => {
  const [{ value: audienceType }] = useField<AudienceTypeOptionsType>(
    'audienceProfile.audienceType',
  );

  if (audienceType !== 'custom') {
    return null;
  }

  return (
    <>
      <div className="grid grid-cols-[300px_1fr]">
        <div>Audience Targets</div>
        <div className="max-w-[500px]">
          <DemographicTargets />
        </div>
      </div>
    </>
  );
};
